import { defineMessages } from 'react-intl';

export default defineMessages({
  basicInformation: {
    id: 'civil_proceeding_modal.basic_information.title',
  },
  hearingDateField: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.title',
  },
  dateReceiptRequestField: {
    id:
      'civil_proceeding_modal.basic_information.date_receipt_request_field.title',
  },
  updatedRequest: {
    id: 'toast.success.requestUpdated.title',
  },
  updateTitle: {
    id: 'general.title.update',
  },
  opposingLawyerField: {
    id: 'civil_proceeding_modal.opposingLawyer',
  },
  circomscriptionField: {
    id: 'civil_proceeding_modal.circomscription',
  },
  jurisdictionField: {
    id: 'civil_proceeding_modal.percentage_juridiction',
  },
  town: {
    id: 'preopening_page.victim.city',
  },
  courtNumber: {
    id: 'civil_proceeding_modal.basic_information.court_number.title',
  },
  damageAffectedByTheProcedure: {
    id: 'civil_proceeding_modal.damage_affected_by_the_procedure',
  },
  corporeal: {
    id: 'civil_proceeding_modal.corporeal',
  },
  material: {
    id: 'civil_proceeding_modal.material',
  },
  victimsTitle: {
    id: 'civil_proceeding_modal.victims.title',
  },
  victimSelect: {
    id: 'civil_proceeding_modal.victims.select_victim',
  },
  addVictim: {
    id: 'preopening_page.victim.add_victim',
  },
  adverseVehicles: {
    id: 'civil_proceeding_modal.adverse-vehicles',
  },
  opposingParties: {
    id: 'civil_proceeding_modal.opposingLawyer.title',
  },
  addOpposingParty: {
    id: 'civil_proceeding_modal.add_opposing_party',
  },
  otherProperties: {
    id: 'civil_proceeding_modal.other-properties',
  },
  audience: {
    id: 'civil_proceeding_modal.audience',
  },

  supportingDocuments: {
    id: 'civil_proceeding.supportingDocuments',
  },
  citation: {
    id: 'civil_proceeding_modal.upload_request_citation.title',
  },
  request: { id: 'civil_proceeding_modal.upload_request.title' },
  action: {
    id: 'action.title',
  },
  civilProceedingTitle: {
    id: 'civil_proceeding_modal.title',
  },
  commercialproceedingTitle: {
    id: 'commercial_proceeding_modal.title',
  },
  successDialogCivilProceeding: {
    id: 'civil_proceeding.success',
  },
  civilAdd: {
    id: 'save_btn',
  },
  civilCancel: {
    id: 'cancel_btn',
  },
  hearingDateError: {
    id: 'civil_proceeding_modal.basic_information.date_hearing_field.error',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
});
